import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface GetUserResponse {
  _id: string
  email: string
  name: string
  picture: string
  active: boolean
  created_at: Date
  updated_at: Date
  is_admin: boolean
  is_root: boolean
}

export async function getUser(
  companyId: string,
  userId: string,
): Promise<GetUserResponse> {
  const resp = await api.get<GetUserResponse>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/company/${companyId}/user/${userId}`,
  )

  return resp.body
}
